import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from 'src/app/core/service/config.service';
import { MultiAuctionService } from 'src/app/features/multi-auction-bidder/core/service/multi-auction.service';

@Component({
  selector: 'app-withdraw-multi-room',
  templateUrl: './withdraw-multi-room.component.html',
  styleUrls: ['./withdraw-multi-room.component.css']
})
export class WithdrawMultiRoomComponent implements OnInit {

  loading =false;
  constructor(
    public dialogRef: MatDialogRef<WithdrawMultiRoomComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _api:MultiAuctionService,
    public _config : ConfigService,
    public translate : TranslateService
  ) { }

  ngOnInit() {
  }

  join(){
 this.loading = true;
    this._api.withdrawAuction(this.data.id).subscribe({
      next : (data) =>{
        this.loading = false;
        this._config.toastrService.success(data.message);
        this.dialogRef.close('success');
      }, error: (error: any) => {
        // error.errors.forEach((err: any) => {
        //   this._config.toastrService.error(err.massage);
        // });
        this._config.showErrors(error);

        this.loading = false;
      }
    })
  }

}
